<section class="paginator tw-py-5 tw-px-3 border-top">
  <div class="tw-flex flex-wrap">
    <!-- number of records -->
    <div class="tw-flex tw-justify-start tw-items-center">
      <div>
        <span>{{ "common.numberOfRecords" | translate }}</span>
        <span
          *ngIf="totalCount > 999"
          class="text-dark tw-mr-2 tw-font-medium"
          >{{ totalCount | number : "3." }}</span
        >
        <span
          *ngIf="totalCount < 1000"
          class="text-dark tw-mr-2 tw-font-medium"
          >{{ totalCount }}</span
        >
      </div>
    </div>
  </div>

  <!-- buttons -->
  <div class="tw-flex tw-justify-end tw-items-center tw-mx-1">
    <!-- previous btn -->
    <ng-container>
      <!-- first page button -->
      <button
        [disabled]="!hasPreviousPage"
        mat-ripple
        (click)="firstPage()"
        class="btn btn-icon btn-sm border-0 tw-mr-[5px] ltr:tw-ml-[5px] ltr-rotate-180"
        [themeColor]="'btn-light'"
      >
        <i class="mdi mdi-chevron-double-right mdi-20px"></i>
      </button>
      <!-- previous page button -->
      <button
        [disabled]="!hasPreviousPage"
        mat-ripple
        (click)="previousPage()"
        class="btn btn-icon btn-sm border-0 tw-mr-[5px] ltr:tw-ml-[5px] ltr-rotate-180"
        [themeColor]="'btn-light'"
      >
        <i class="mdi mdi-chevron-right mdi-20px"></i>
      </button>
    </ng-container>

    <!-- pageNumber -->
    <div class="tw-flex-center">
      <span class="tw-mx-1">{{ "common.page" | translate }} </span>
      <input
        class="form-control gray-border form-control-sm tw-text-center tw-w-[50px] tw-mx-1 fw-bold"
        type="text"
        [(ngModel)]="pageIndex"
        (change)="emitPageNumber(pageIndex)"
      />
      <span class="tw-mx-1">{{ "common.from" | translate }}</span>
      <span *ngIf="totalPages > 999" class="tw-mx-1 tw-font-medium text-dark">{{
        totalPages | number : "3."
      }}</span>
      <span
        *ngIf="totalPages < 1000"
        class="tw-mx-1 tw-font-medium text-dark"
        >{{ totalPages }}</span
      >
    </div>

    <!-- next btn -->
    <ng-container>
      <!-- next page button -->
      <button
        [disabled]="ignoreDisableBtn ? false : !hasNextPage"
        mat-ripple
        (click)="nextPage()"
        class="btn btn-icon btn-sm border-0 tw-mr-[5px] ltr:tw-ml-[5px] ltr-rotate-180"
        [themeColor]="'btn-light'"
      >
        <i class="mdi mdi-chevron-left mdi-20px"></i>
      </button>

      <!-- last page button -->
      <button
        [disabled]="!hasNextPage"
        mat-ripple
        (click)="lastPage()"
        class="btn btn-icon btn-sm border-0 tw-mr-[5px] ltr:tw-ml-[5px] ltr-rotate-180"
        [themeColor]="'btn-light'"
      >
        <i class="mdi mdi-chevron-double-left mdi-20px"></i>
      </button>
    </ng-container>
  </div>

  <div class="tw-flex flex-wrap">
    <!-- NumberOfViews -->
    <div
      *ngIf="!hidePageSize"
      class="tw-flex tw-justify-start tw-items-center tw-mx-1"
    >
      <!-- page size -->
      <div class="tw-flex tw-items-center pagesize">
        <span class="tw-ml-2">
          {{ "common.numberOfViews" | translate }}
        </span>
        <select
          #pageSize
          (change)="emitPageSize(pageSize.value)"
          [ngModel]="defaultPageSize"
          class="form-control tw-cursor-pointer gray-border tw-py-1 form-control-sm fw-bold tw-w-[75px] ng-valid ng-dirty ng-touched"
        >
          <option *ngFor="let size of pageSizes" [value]="size" class="btn">
            {{ size }}
          </option>
        </select>
      </div>
    </div>
  </div>
</section>
